import type { ComponentProps } from 'react';
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { type Image, theme } from '@sg/garnish';

import {
  NotFoundViewCtaV2,
  NotFoundViewDescription,
  NotFoundViewImage,
  NotFoundViewTitle,
} from './NotFoundView.components';

// ────────────────────────────────────────────────────────────────────────────────

export const NotFoundViewV2 = (props: Props) => {
  const {
    illustration,
    title,
    description,
    btnLabel,
    withoutCta,
    onBtnPress,
    onMount,
  } = props;

  // ─── Effects ─────────────────────────────────────────────────────

  useEffect(() => {
    onMount?.();
  }, [onMount]);

  // ─────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <NotFoundViewImage illustration={illustration} />
      <NotFoundViewTitle title={title} />
      <NotFoundViewDescription description={description} />

      {withoutCta ? null : (
        <NotFoundViewCtaV2 btnLabel={btnLabel} onBtnPress={onBtnPress} />
      )}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.APP_BACKGROUND,
    paddingVertical: theme.spacing['10'],
    paddingHorizontal: theme.spacing['6'],
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────────

type Props = {
  illustration?: ComponentProps<typeof Image>['source'];
  title?: string;
  description?: string;
  btnLabel?: string;
  withoutCta?: boolean;
  onBtnPress?: () => void;
  onMount?: () => void;
};
